import { render, staticRenderFns } from "./u-scrolldown-filled.vue?vue&type=template&id=73add6c7&scoped=true&"
import script from "./u-scrolldown-filled.vue?vue&type=script&lang=js&"
export * from "./u-scrolldown-filled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73add6c7",
  null
  
)

export default component.exports